<template>
  <div id="error404" class="bg-white">
    <section class="w-100 pt-5 text-center d-table h-100">
      <div class="d-table-cell align-middle">
        <h1 class="my-5 text-28 text-lg-34 text-primary fw-700">
          페이지를 찾을 수 없습니다!
        </h1>
        <p class="text-16 text-lg-18 text-grey-dark">
          길을 잘못 찾아오신 것 같습니다. 다시 돌아가볼까요? <br />
          <b-button
            variant="primary"
            class="my-3"
            pill
            @click="$router.push('/')"
          >
            <span class="text-16 text-lg-16">메인페이지로 돌아가기</span>
            <i
              class="icon icon-sm-24 icon-28 icon-arr-right-white ml-1 mb-n2"
            ></i>
          </b-button>
        </p>
        <img
          :src="require('../assets/character-thumbnail-both.png')"
          alt="갸우뚱"
        />
      </div>
    </section>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
#error404 {
  height: 100vh;
  min-height: 100vh;
}
img {
  margin-top: 4rem;
  margin-left: 8rem;
  width: 35% !important;
  @media all and (max-width: 768px) {
    width: 80% !important;
    margin-left: 0 !important;
  }
}
</style>
